import React from "react";
import { InputText } from "../../components/Input";


import "./index.css";


export default function Login(props){


    async function login(event){
        event.preventDefault();
        let email = event.target.correo.value;
        let password = event.target.password.value;
        let data = {email, password};
        let res = await fetch("https://login-s2c5sazw3q-uc.a.run.app", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });

        let json = await res.json();
        if(json.error === false){
            localStorage.setItem("JWT", json.token);
            window.location.assign("/admin/"+ json.local_id);
        }
        //console.log(json);
    }

    return (<div>
        <form onSubmit={ login } className="login-form">
            <h1 style={ {marginTop: 20} }>Incia sesión</h1>

            <InputText placeholder="Correo" type="email" name="correo"></InputText>
            <InputText placeholder="Contraseña" type="password" name="password"></InputText>

            <button className="btn" style={ {marginTop: 20} }>INICIAR</button>

        </form>
    </div>);
}